import React, {useState} from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";
import EditableInput from "../../../../string/render/inline-editable/input-component";
import number_checkValueIsValid from "../../../../number/render/helpers/check-value-is-valid"
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

const debug = false
// const debug = "FieldCurrency_Editable"

export default function FieldCurrency_Editable(props:FieldEditableProps) {

    debug && console.log(debug, props)

    const value         = props.field.getViewValue(props.model)
    const displayValue  = props.field.getDisplayValue(value)

    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)
    const [inputValue, setInputValue] = useState<string | null>(displayValue)

    const onMouseEnter = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (mode===FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode !== FieldEditableMode.EDITING) setMode(FieldEditableMode.EDITING)
    }

    const onDeleteClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        onChange(null)
    }

    const onChange = (newValue:any) => {
        if(number_checkValueIsValid(props.field, inputValue) || newValue === null){
            props.onChange && props.onChange(newValue)
        }else{
            setInputValue(null)
        }


        setMode(FieldEditableMode.VIEW)
    }
    const currencyId = props.field ? props.field.symbolId : null;
    let currencyMark = !!currencyId ? gd.const.currency[currencyId].symbol : '';

    const classes = Classes("ui5-field-editable", props.className, "p-0", {
        "ui5-txt-default"               : props.size === FieldViewSize.DEFAULT,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "ui5-txt-less-important-small"  : props.size === FieldViewSize.SMALL,
        "size-small"                    : props.size === FieldViewSize.SMALL,
        "invalid-value"                 : !number_checkValueIsValid(props.field, value)
    })

    const renderEditing = () => {

        return (
            <div className={classes}>
                <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-100-percent h-36"
                               inputClassName   = "view-value h-100-percent"
                               value            = {value}
                               focusOnMount     = {true}
                               placeholder      = {props.field.placeholder}
                               onChange         = {onChange}
                               onImmediateChange= {setInputValue}/>
            </div>
        )
    }


    const renderHovered = () => {

        const hoveredClasses = Classes(classes, "is-hovered", "p-h-10")

        return (
            <div className={hoveredClasses}
                 onClick={onClick}
                 onMouseLeave={onMouseLeave}
            >
                <div className="txt-truncate">
                    {!!displayValue && (
                        <div className="flex-row-left-center">
                            <div className="symbol m-r-5">{currencyMark}</div>
                            <div className="max-w-100-percent txt-truncate">{displayValue}</div>
                        </div>
                    )}
                </div>

                <div className="buttons">
                    {!!displayValue && <div className="btn-reset" onClick={onDeleteClick}/>}
                </div>
            </div>
        )
    }

    const renderView = () => {

        return (
            <div className={classes}
                 onMouseEnter={onMouseEnter}
                 onClick={onClick}>
                {!!displayValue && (
                    <div className="flex-row-left-center p-h-10">
                        <div className="symbol m-r-5">{currencyMark}</div>
                        <div className="max-w-100-percent txt-truncate">{displayValue}</div>
                    </div>
                )}
            </div>
        )
    }

    switch (mode) {

        case FieldEditableMode.EDITING:
            return renderEditing()

        case FieldEditableMode.HOVERED:
            return renderHovered()

        case FieldEditableMode.VIEW:
        default:
            return renderView()
    }
}
